import { NavLink } from "react-router-dom";
import {
  Footer,
  FooterBrand,
  FooterCopyright,
  FooterLinkGroup,
} from "flowbite-react";
import "./footerGt.css";

function FooterGt() {
  return (
    <Footer container className="rounded-none shadow-none flex flex-col items-center justify-center">
      <div id="div-footer-links" className="w-full">

        <FooterLinkGroup id="footerLinkGroup" className="flex flex-col items-center text-center gap-2 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-6 sm:gap-y-2">
          <li>
            <NavLink
              className=""
              to="/about"
            >
              À propos
            </NavLink>
          </li>
          <li>
            <NavLink
              className=""
              to="/faq">FAQ
            </NavLink>
          </li>
          <li>
            <NavLink
              className=""
              to="/contact"
            >
              Nous contacter
            </NavLink>
          </li>
          <li>
            <NavLink
              className=""
              to="/charter-of-good-conduct"
            >
              Charte de bonnes conduites
            </NavLink>
          </li>
          <li>
            <NavLink
              className=""
              to="/info-legal"
            >
              Informations légales
            </NavLink>
          </li>
          <li>
            <NavLink
              className=""
              to="/terms-services"
            >
              CGU/V
            </NavLink>
          </li>
          <li>
            <NavLink
              className=""
              to="/privacy-policy"
            >
              Politique de confidentialité
            </NavLink>
          </li>
        </FooterLinkGroup>

      </div>

      <div id="logo-and-copyright" className="flex items-center">
        <FooterBrand
          id="logo-footer"
          className="sm:mb-0 w-10 sm:w-12 h-auto"
          src='/logo-cemade.png'
          alt="CÉMADE Logo"
        />
        <FooterCopyright className="text-xs" href="#" by=" CEMADE™. Tous droits réservés." year={2025} />
      </div>
    </Footer>
  );
}

export default FooterGt;
